import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import clsx from 'clsx'
import { makeStyles, useTheme } from '@mui/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

import PropTypes from 'prop-types'

import lang from '@/lang'

import Checkbox from '@/modules/base/components/inputs/checkbox/checkbox'
import avvPdf from '@assets/downloads/avv-orgamax-102024.pdf'
import { switchAvvState, switchAgbState } from '@/redux/ducks/onboarding/main-v2'
import AvvModal from '@/modules/base/components/modal/avv-modal/avv-modal'

const useStyles = makeStyles((theme) => ({
  column: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: 0,
    [theme.devices.mobile]: {
      padding: 0,
    },
  },
  checkboxContainer: {
    marginTop: 20,
  },
  checkboxTextWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  checkboxLabel: ({ isMeinBuero }) => {
    return {
      textAlign: 'left',
      paddingLeft: '10px',
      fontSize: isMeinBuero ? theme.fontSizes.default : theme.fontSizes.smaller,
      fontWeight: '500',
    }
  },
  descriptionWrapper: ({ isMeinBuero, isTaxConsultant }) => ({
    paddingLeft: 10,
    marginTop: 12,
    fontSize: isMeinBuero ? theme.fontSizes.smaller : theme.fontSizes.extrasmall,

    [theme.devices.mobile]: {
      fontSize: isMeinBuero ? theme.fontSizes.smaller : theme.fontSizes.small,

      '& > ul > li': {
        marginTop: 12,
      },
    },

    ...(isMeinBuero && !isTaxConsultant && {
      margin: isMeinBuero ? '12px 0' : 'inherit',
      padding: isMeinBuero ? '0 30px' : '0 10px',
      display: 'flex',
      flexDirection: 'column',
      gap: 20,
    }),
  }),
}))

const AcceptAvvForm = (props) => {
  const isMeinBuero = ENV.product === 'meinbuero'
  const { setInputsValid, isTaxConsultant } = props
  const dispatch = useDispatch()
  const [avvModalOpen, setAvvModalOpen] = useState(false)
  const { acceptAvv, acceptAgb } = useSelector(state => state.onboarding.mainV2)
  const classes = useStyles({ isMeinBuero, isTaxConsultant })

  useEffect(() => {
    setInputsValid(acceptAvv && acceptAgb)
  }, [acceptAvv, acceptAgb])

  const handleChangeAvvAndAgbCheck = () => {
    dispatch(switchAvvState())
    dispatch(switchAgbState())
  }

  const closeAvvModal = () => {
    setAvvModalOpen(false)
  }

  const openAvvModal = () => {
    setAvvModalOpen(true)
  }

  const onAVVClicked = (event) => {
    if (isMeinBuero) {
      openAvvModal()
    } else {
      event.stopPropagation()
      window.open(avvPdf)
    }
  }

  const avvModal = isMeinBuero ? <AvvModal open={avvModalOpen} onClose={closeAvvModal} /> : null

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.devices.mobile)

  const avvTitle = isMobile ? lang.onboardingV2.avv.texts.avvShort : lang.onboardingV2.avv.texts.avv
  const mobileTarget = isMobile ? '_blank' : '_self'
  const avvLink = <a onClick={onAVVClicked} target={mobileTarget} rel="noopener noreferrer">{avvTitle}</a>
  const avvText = isMobile ? lang.onboardingV2.avv.texts.avvTextMobile(avvLink) : lang.onboardingV2.avv.texts.avvText(avvLink)

  return (
    <div className={classes.column}>
      <Checkbox
        checked={acceptAvv}
        onChange={handleChangeAvvAndAgbCheck}
        name='acceptAvv'
        inputPosition="top"
        customClass={classes.checkboxContainer}>
        <div className={classes.checkboxTextWrapper}>
          <span className={clsx(classes.checkboxLabel)}>
            {avvText}
          </span>
          {!isMeinBuero
            ? <div className={classes.descriptionWrapper} dangerouslySetInnerHTML={{ __html: lang.onboardingV2.avv.description }} />
            : null}
        </div>
      </Checkbox>
      {isMeinBuero
        ? <div className={classes.descriptionWrapper}>
          { !isTaxConsultant && <div>{lang.onboardingV2.avv.description2}</div> }
          <div dangerouslySetInnerHTML={{ __html: lang.onboardingV2.avv.description }} />
        </div>
        : null}
      {avvModal}
    </div>
  )
}

AcceptAvvForm.propTypes = {
  setInputsValid: PropTypes.func,
  isTaxConsultant: PropTypes.bool,
}

AcceptAvvForm.defaultProps = {
  setInputsValid: () => {},
  isTaxConsultant: false,
}

export default AcceptAvvForm
